import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import { useAppContext } from 'new-components/OpAppScaffold/AppContext';
import { getMailroomOrigin } from 'utils/getMailroomOrigin';
import { useIsMailroomEnabled } from './useIsMailroomEnabled';

export const useNavigateToMailroom = ({ orgId }: { orgId: number }) => {
  const { app } = useAppContext();

  const { isMailroomEnabled, isLoading: isLoadingIsMailroomEnabled } =
    useIsMailroomEnabled({ orgId });

  const navigate = useNavigate();

  const handleNavigateToMailroom = useCallback(() => {
    if (isLoadingIsMailroomEnabled) {
      return;
    }

    if (!isMailroomEnabled) {
      // go to marketing page
      window.open(
        'https://www.avigilon.com/mailroom',
        '_blank',
        'noopener,noreferrer',
      );
      return;
    }

    if (app === 'mailroom') {
      navigate(0);
      return;
    }

    window.open(`${getMailroomOrigin()}/o/${orgId}`, '_blank');
  }, [app, navigate, orgId, isLoadingIsMailroomEnabled, isMailroomEnabled]);

  return {
    handleNavigateToMailroom,
    isLoading: isLoadingIsMailroomEnabled,
  };
};
